export default __webpack_public_path__ + "static/media/background.b97b7fec.jpg";